import { localStorageGetItem } from "../utils/LocalStorage";
import Configs from "../config";
import { IShopifyProduct } from "../generated/Api";

async function checkDomainAndApiKey(params: { apiKey: string; url: string }) {
  const { apiKey, url } = params;

  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/shopify/check`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({
      apiKey,
      url,
    }),
  });

  if (!response.ok) return { ok: false };

  const responseJSON: { ok: boolean } = await response.json();

  return responseJSON;
}

async function createWebhooks() {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(
    `${Configs.SERVER_URL}/shopify/create_webhooks`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",

        Authorization: "Bearer " + token,
      },
    }
  );

  if (!response.ok) return { ok: false };

  const responseJSON: { ok: boolean } = await response.json();

  return responseJSON;
}

async function disconnectAndClearWebhooks() {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/shopify/disconnect`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",

      Authorization: "Bearer " + token,
    },
  });

  if (!response.ok) return { ok: false };

  const responseJSON: { ok: boolean } = await response.json();

  return responseJSON;
}

async function getProducts() {
  const token = localStorageGetItem("USER_TOKEN");
  const response = await fetch(`${Configs.SERVER_URL}/shopify/products`, {
    method: "GET",
    headers: {
      Accept: "application/json",

      Authorization: "Bearer " + token,
    },
  });

  const responseJSON: { products: IShopifyProduct[] } = await response.json();

  return responseJSON;
}

export const ShopifyAPI = {
  createWebhooks,
  disconnectAndClearWebhooks,
  checkDomainAndApiKey,
  getProducts,
};
